import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import RouterDOM from "./Router";
import usePageViews from "./hooks/usePageViews";
import { fetchUserCount } from "./services/keycloakservice";

// eslint-disable-next-line react-refresh/only-export-components -- app entry mounts root; not a Fast Refresh module
const App = () => {
  usePageViews(); // Called inside Router context now

  // Auto-fetch user count when app loads
  React.useEffect(() => {
    const getInitialUserCount = async () => {
      try {
        const count = await fetchUserCount();
        if (count !== null) {
          console.log("Initial user count fetched successfully:", count);
        } else {
          console.log("Initial user count fetch returned null");
        }
      } catch (error) {
        console.error("Failed to fetch initial user count:", error);
      }
    };

    // Fetch immediately when app loads
    getInitialUserCount();

    // Set up interval to fetch every 5 minutes (300000 ms)
    const interval = setInterval(getInitialUserCount, 300000);

    // Cleanup interval on unmount
    return () => {
      clearInterval(interval);
      console.log("User count fetching stopped");
    };
  }, []);

  return <RouterDOM />;
};

const container = document.getElementById("root");
if (!container) throw new Error("Root container not found");

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
